import styled from 'styled-components';

const ActivityResultStyled = styled.div`
  margin-top: 4px;
  /* border-radius: 10px; */
  margin-top: 24px;
  flex-grow: 1;
  .activity-num-wrap,
  .user-statistics-content {
    display: flex;
    flex-direction: row;
    margin-top: 24px;
    /* justify-content:space-between; */
  }
  .statistics-wrap-first {
    width: 50%;
  }
  .user-statistics-content {
    gap: 34px;
    /* justify-content: space-between; */
  }
  .activity-num-wrap {
    gap: 24px;
    justify-content: space-between;
    .user-statistics-wrap {
      flex: 1 auto;
      padding: 24px;
      background: #fafafa;
      box-shadow: 0px 0px 5px 0px rgba(181, 181, 181, 0.26);
      border-radius: 8px;
      .user-statistics-title {
        display: flex;
        flex-direction: row;
        gap: 8px;
        font-size: 16px;
        font-weight: 500;
        color: #212121;
        line-height: 22px;
      }
      .statistics-content-title {
        font-size: 16px;
        font-weight: 400;
        color: #616161;
        line-height: 22px;
      }
      .statistics-content-register {
        font-size: 30px;
        font-weight: 600;
        color: #1565c0;
        line-height: 42px;
        /* min-width: 174px; */
      }
      .statistics-content-today {
        margin-left: 8px;
        font-size: 16px;
        font-weight: 600;
        color: #212121;
        line-height: 22px;
      }
    }
    .statistics-wrap-right {
      width: 50%;
      display: flex;
      flex-direction: row;
      gap: 24px;
      flex: 1 auto;
    }
  }
  .activity-echarts-wrap {
    display: flex;
    flex-direction: row;
    gap: 24px;
    margin-top: 32px;
    .echarts-wrap {
      width: 50%;
      box-shadow: 0px 0px 5px 0px rgba(181, 181, 181, 0.26);
      border-radius: 1px;
      padding: 24px;
      .right-echarts-title {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        .echarts-title-left {
          display: flex;
          flex-direction: row;
          gap: 16px;
          align-items: center;
          img {
            width: 46px;
          }
          .title-left-center {
            word-break: keep-all;
            display: flex;
            flex-direction: column;
            span:nth-child(1) {
              font-size: 20px;
              font-weight: 500;
              color: #212121;
              line-height: 24px;
            }
            span:nth-child(2) {
              font-size: 12px;
              font-weight: 400;
              color: #616161;
              line-height: 17px;
            }
          }
          .title-left-funnelPlot {
            width: 46px;
            height: 46px;
            background: #f5f5f5;
            border-radius: 50%;
            position: relative;
            .icon {
              position: absolute;
              margin: auto;
              left: 0;
              top: 0;
              right: 0;
              bottom: 0;
            }
          }
        }
        .echarts-title-right {
          display: flex;
          align-items: center;
          font-size: 16px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.87);
          line-height: 24px;
          .basic-name {
            text-align: right;
            width: 28px;
          }
          .noLastPage {
            color: #9e9e9e;
          }
          .lastPage {
            color: #000000;
            cursor: pointer;
          }
        }
      }
      .user-echarts-wrap {
        margin-top: 50px;
      }
    }
  }
  .barline-wrap-top {
    margin-top: 51px;
  }
  .barline-wrap {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-size: 14px;
    font-weight: 500;
    color: #616161;
    line-height: 20px;
    margin: 16px 0 8px;
    .barline-left-wrap {
      width: 223px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .barline-left-num {
        font-size: 12px;
        width: 16px;
        height: 16px;
        background: #f5f5f5;
        border-radius: 1px;
        margin-right: 4px;
        padding: 1px 4px;
      }
      .barline-left-title {
      }
    }
  }
`;

export default ActivityResultStyled;
